/**
 * API Configuration
 * Centralized configuration for API endpoints and behavior
 */

const envBase = process.env.REACT_APP_API_URL;
if (process.env.NODE_ENV === 'production' && !envBase) {
  throw new Error('REACT_APP_API_URL must be set in production');
}

export const API_CONFIG = {
  // Base URL for API requests
  baseUrl: envBase || 'https://api.barkada.us',
  
  // Timeout for API requests (in milliseconds)
  timeout: 10000,
  
  // Number of retry attempts for failed requests
  retryAttempts: 3,
  
  // Use mock data for development (disabled by default)
  useMockData: false,
  
  // Enable debug logging
  debug: process.env.NODE_ENV === 'development',
  
  // API endpoints
  endpoints: {
    auth: {
      login: '/auth/login',
      register: '/auth/register',
      me: '/users/me',
    },
    users: {
      search: '/users/search',
      profile: '/users/me',
      update: (userId: string) => `/users/${userId}`,
    },
    friends: {
      list: '/friends',
      requests: {
        pending: '/friends/requests/pending',
        sent: '/friends/requests/sent',
        send: '/friends/requests/send',
        accept: (id: string) => `/friends/requests/${id}/accept`,
        decline: (id: string) => `/friends/requests/${id}/decline`,
        cancel: (id: string) => `/friends/requests/${id}/cancel`,
      },
      remove: (friendId: string) => `/friends/${friendId}`,
      status: (userId: string) => `/friends/status/${userId}`,
      notifications: '/friends/notifications',
      markRead: (id: string) => `/friends/notifications/${id}/read`,
    },
  },
};


